import './NotificationLink.scss';

import React from 'react';
import RouterLink from '../../components/RouterLink';
import { getResourceUrl } from '../helpers';
import { useDispatch } from 'react-redux';
import { markAsRead } from '../actions';
import { NotificationData, NotificationsDispatch } from '../notifications-types';

export type NotificationLinkProps = {
  notificationData: NotificationData;
  handleNotificationCenterOpen: (isOpen: boolean) => VoidFunc;
};

export default function NotificationLink({ notificationData, handleNotificationCenterOpen }: NotificationLinkProps) {
  const dispatch = useDispatch<NotificationsDispatch>();

  if (!notificationData) {
    return null;
  }

  const handleLinkClick = () => {
    handleNotificationCenterOpen(false)();
    markAsRead([notificationData], dispatch);
  };

  if (notificationData.link?.resourceId && notificationData.link?.resourceType) {
    return (
      <RouterLink
        className="notification-link"
        to={getResourceUrl(notificationData.link?.resourceType, notificationData.link?.resourceId)}
        target="_self"
        onClick={handleLinkClick}
      >
        {notificationData.link?.text}
      </RouterLink>
    );
  } else if (notificationData.link?.url) {
    return (
      <a className="notification-link" href={notificationData.link?.url} target="_self" onClick={handleLinkClick}>
        {notificationData.link?.text}
      </a>
    );
  }

  return null;
}
